
import DateTimePicker from '@/components/DateTimePicker'
import SliderComponent from 'react-slick'
import Swiper from '@/components/swiper'
import { Col, Row, Image, Button, Table, Select, Carousel, Modal, message, Spin } from 'antd'
import {tradeDataP} from "./trade"
import {sampleDataP} from './sample'
import { useState, useEffect, createRef } from 'react'
import { Document, Page, pdfjs } from 'react-pdf'
// import {WebView} from 'react-native-webview'

import 'react-pdf/dist/esm/Page/AnnotationLayer.css'
// 设置 pdfjs 的 worker 路径
pdfjs.GlobalWorkerOptions.workerSrc = `//cdnjs.cloudflare.com/ajax/libs/pdf.js/${pdfjs.version}/pdf.worker.min.js`
// 添加字体加载配置，忽略字体映射错误
pdfjs.GlobalWorkerOptions.workerOptions = {
  disableFontFace: true // 禁用字体加载以避免字体映射错误
}
import {
  CheckOutlined,
  SearchOutlined,
  ArrowLeftOutlined,CheckCircleOutlined,
  CloseCircleOutlined,
  ZoomInOutlined,
  ZoomOutOutlined,
  CaretDownOutlined,
  ToTopOutlined,
  CloseOutlined
} from '@ant-design/icons'
import NoDataImg from '@/assets/img/home/noData.png'
import btmBgImg from '@/assets/img/home/btmBg.png'
import fireCornerImg from '@/assets/img/home-goods/fire-corner.png'
import fireRedCornerImg from '@/assets/img/home-goods/fire-red.png'
import fireHealth from '@/assets/img/home-goods/health-icon.png'
import hotBg from '@/assets/img/home/hot_bg.png'

import 'react-photo-view/dist/react-photo-view.css'

import PageFooter from '@/components/sc/PageFooter'
import './index.less'
import api from '@/net/api'
import moment from 'moment'
import _ from 'lodash'
import { useDispatch, useSelector } from 'react-redux'
import storeUser, { sysuserInfoSlice, btmImgSlice } from '@/store'
// import storeUser from '@/store'

export default function DingzhiHome(props) {
  let { location, history, route } = props
  const dispatch = useDispatch()
  const { Option } = Select
  const [isSearch, setIsSearch] = useState(false)
  const [banner, setBanner] = useState([])
  const [dataList, setDataList] = useState([])
  const [dataSource1, setDataSource1] = useState([])
  const [dataSource2, setDataSource2] = useState([])

  const [list, setList] = useState([])
  const [restaurant, setRestaurant] = useState([])
  const [store, setStore] = useState([])
  const { buyerOrgId: orgRegionId, screenPriceShow, id } = storeUser.getState().sysuserInfo

  const [isOpen, setIsOpen] = useState(false)
  const [zoom, setZoom] = useState(1)
  const [imgPX, setImgPX] = useState({ width: 1080, height: 485 })
  const [right, setRight] = useState(0)
  const [configValue, setConfigValue] = useState([2, 2, 2])
  const [selectedHotWindowList, setSelectedHotWindowList] = useState([])
  const [hotSaleWindowList, setHotSaleWindowList] = useState([])
  const [customPicList, setCustomPicList] = useState([null, null, null])
  // 留样记录
  const [sampleRecord, setSampleRecord] = useState([])
  // 交易明细
  const [tradeData, setTradeData] = useState([])
  // 巡查巡检
  const [inspectionData, setInspectionData] = useState([])
  // 晨检记录
  const [checkData, setCheckData] = useState([])

  // let dbtPicUrl = 'https://cdn.rongdaufun.com/spa/other/scImgs/yyzc.png'
  const [dbtPicUrl, setDbtPicUrl] = useState([{ url: 'https://cdn.rongdaufun.com/spa/other/scImgs/yyzc.png' }])
  const [curDbtPicUrl, setCurDbtPicUrl] = useState('https://cdn.rongdaufun.com/spa/other/scImgs/yyzc.png')

  // let params = location.search.split('?id=')[1]
  // console.log(params)
  // let rid = id?id:Base64.decode(params)
  // console.log(location.search,rid)

  // 搜索条件
  const [searchParams, setSearchParams] = useState({
    startDate: moment().subtract(1, 'd').hour(0).minute(0).second(0),
    endDate: moment().hour(23).minute(59).second(59),
    restaurantId: null,
    storeId: null,
    productName: null,
    orgRegionIds: orgRegionId
  })
  // 分页
  const [page, setPage] = useState({
    currentPage: 1,
    pageSize: 6,
    total: 0
  })
  
  useEffect(() => {
    console.log(111)
    let params = location.search.split('?id=')[1]
    console.log(params)
    let rid = Base64.decode(params)
    let timer
    // 获取学校/组织信息
    api
      .display_info({ rid })
      .then(d => {
        setSearchParams({ ...searchParams, orgRegionIds: d.buyerOrgId })
        dispatch(sysuserInfoSlice.actions.save(d))
        getList(d.buyerOrgId)
        getBanner(d.buyerOrgId)
        postSampleScale(d.buyerOrgId)
        getInspectionRecord(d.buyerOrgId)
        postRecordSelectList2(d.buyerOrgId)
        getRestaurantList({
          orgRegionIds: d.buyerOrgId
        })
        setTradeData(tradeDataP)
        // setSampleRecord(sampleDataP)
        getProductNameList({
          restaurantId: null,
          storeId: null,
          productName: null,
          orgRegionIds: d.buyerOrgId
        })
        getPageDetail(rid)
        timer = setInterval(() => {
          if (!isSearch) {
            getList(d.buyerOrgId)
          }
        }, 30 * 60 * 1000) //

        sampleTimer = setInterval(() => {
          postSampleScale(d.buyerOrgId)
        }, 5 * 60 * 1000)
      })
      .catch(err => { })

    return () => {
      clearInterval(timer)
      clearInterval(sampleTimer)
    }
  }, [])
  // 晨检记录列表-餐厅服务机
  function postRecordSelectList2(buyerOrgId) {
    api
      .post_record_selectList2({
        buyerOrgId,
        startTime: moment().startOf('day').format('YYYY-MM-DD HH:mm:ss') ,
        endTime: moment().endOf('day').format('YYYY-MM-DD HH:mm:ss')
      })
      .then(res => {
        setCheckData(res)
      })
  }
  // 留样记录列表-餐厅服务机
  function postSampleScale(buyerOrgId) {
    api
      .post_sample_scale_record_list2({
        buyerOrgId
      })
      .then(res => {
        setSampleRecord(res)
      })
  }
  // 巡查巡检记录列表-餐厅服务机
  function getInspectionRecord(buyerOrgId) {
    api
      .post_inspectionRecord_list({
        buyerOrgId,
        startTime: moment().subtract(2,'day').startOf('day').format('YYYY-MM-DD HH:mm:ss') ,
        endTime: moment().endOf('day').format('YYYY-MM-DD HH:mm:ss')
      })
      .then(res => {
        setInspectionData(res)
      })
  }

  // 获取餐厅
  function getRestaurantList(query) {
    let p = {
      startDate: searchParams.startDate,
      endDate: searchParams.endDate,
      orgRegionIds: searchParams.orgRegionIds,
      ...query
    }
    if (p.startDate && typeof p.startDate !== 'string') {
      p.startDate = p.startDate.format('YYYY-MM-DD')
      p.endDate = p.endDate.format('YYYY-MM-DD')
    }
    api.get_foodTraceability_restaurantList(p).then(res => {
      setRestaurant(res || [])
    })
  }
  // 获取门店
  function getStoreList(restaurantId) {
    setSearchParams({ ...searchParams, restaurantId })
    let selectRestaurant = restaurant.filter(item => item.buyerRestaurantId == restaurantId)
    let storeList = selectRestaurant[0]?.storeList || []
    setStore(storeList)
  }
  // 获取商品名称列表
  function getProductNameList(params) {
    let p = {
      ...searchParams,
      ...params
    }

    if (p.startDate && typeof p.startDate !== 'string') {
      p.startDate = p.startDate.format('YYYY-MM-DD')
      p.endDate = p.endDate.format('YYYY-MM-DD')
    }

    api.get_foodTraceability_productNameList(p).then(res => {
      let data = []
      if (res) {
        res?.map((item, index) => {
          data.push({
            label: item,
            value: index
          })
        })
      }

      console.log('list', list)
      setList(data || [])
    })
  }
  
  // useEffect(()=>{
  //   console.log(1111)
  //   getProductNameList()
  // },[searchParams.restaurantId,searchParams.storeId])
  // 获取滚动列表

  async function getList(id) {
    let orgRegionIds = id || searchParams.orgRegionIds

    let p = {
      currentPage: 1,
      orgRegionIds,
      pageSize: 100
    }
    if (searchParams.startDate && typeof searchParams.startDate !== 'string') {
      p.startDate = searchParams.startDate.format('YYYY-MM-DD')
      p.endDate = searchParams.endDate.format('YYYY-MM-DD')
    }

    setLoading(true)
    api.get_foodTraceability_list(p).then(res => {
      let list = res?.list || []
      setDataSource1(list)
      setLoading(false)
    })
  }
  // 获取展厅相关信息
  async function getPageDetail(rid) {
    api.get_display_id(rid).then(res => {
      if (res.length > 0) {
        let _customPicList = _.cloneDeep(customPicList)
        let _configValue = _.cloneDeep(configValue)
        res.map(async tabItem => {
          if (tabItem.infoType == 'RMCK') {
            let keyIndex = tabItem.contentType == '0' ? 1 : 2
            _configValue[0] = keyIndex
            if (tabItem.contentType == '0') {
              _customPicList[0] = null
            } else {
              _customPicList[0] = JSON.parse(tabItem.content)
            }
            try {
              const healList = await getHealList() // 等待 getHealList 执行完成

              if (healList.length > 0) {
                // 当 getHealList 返回有效数据时的处理逻辑
                //如果有健康证先走健康证逻辑
                _configValue[0] = 1
                // if (tabItem.contentType == '0') {
                //   _customPicList[0] = null;
                // } else {
                //   // _customPicList[0] = healList;
                //   _customPicList[0] = null;
                // }
                setSelectedHotWindowList(healList)
              } else {
                if (tabItem.contentType == '0') {
                  setSelectedHotWindowList(JSON.parse(tabItem.content))
                  // _customPicList[0] = null;
                } else {
                  // _customPicList[0] = JSON.parse(tabItem.content);
                }
              }
            } catch (error) {
              console.error('getHealList 出错', error)
              if (tabItem.contentType == '0') {
                setSelectedHotWindowList(JSON.parse(tabItem.content))
                _customPicList[0] = null
              } else {
                _customPicList[0] = JSON.parse(tabItem.content)
              }
            }
          } else if (tabItem.infoType == 'RXSP') {
            let keyIndex = tabItem.contentType == '0' ? 1 : 2
            _configValue[1] = keyIndex
            if (tabItem.contentType == '0') {
              setHotSaleWindowList(JSON.parse(tabItem.content))
              _customPicList[1] = null
            } else {
              _customPicList[1] = JSON.parse(tabItem.content)
            }
          } else {
            let picUrl = JSON.parse(tabItem.content)
            _customPicList[2] = picUrl
            // dbtPicUrl = picUrl[0].url
            setDbtPicUrl(picUrl)
            dispatch(btmImgSlice.actions.save(picUrl))
          }
        })
        setConfigValue(_configValue)
        setCustomPicList(_customPicList)
      }
    })
  }
  async function getHealList() {
    return new Promise((resolve, reject) => {
      api.get_heath_list({ buyerOrgId: storeUser.getState().sysuserInfo.buyerOrgId }).then(res => {
        if (res) {
          resolve(res)
        } else {
          reject(res)
        }
      })
    })
  }
  // 获取搜索列表
  async function getPageList(q) {
    let p = {
      ...searchParams,
      ...page,
      ...q
    }

    if (p.startDate && typeof p.startDate !== 'string') {
      p.startDate = p.startDate.format('YYYY-MM-DD')
      p.endDate = p.endDate.format('YYYY-MM-DD')
    }

    setLoading(true)
    setIsSearch(true)
    api.get_foodTraceability_list(p).then(res => {
      let list = res?.list
      setDataList(list)
      setLoading(false)
      setPage({
        ...page,
        currentPage: p.currentPage,
        total: res.total
      })
    })
  }
  function getBanner(orgRegionId) {
    api
      .popularization_list({
        type: 'USER',
        orgRegionId,
        currentPage: 1,
        pageSize: 3
      })
      .then(res => {
        let list = res?.list
        setBanner(list)
      })
  }
  function goPage(path) {
    props.history.push(path)
  }
  //点击控制图片缩放
  function imgToSize(flag) {
    let imgDom = document.querySelector('.slick-active .img')
    let _zoom = zoom
    if (flag) {
      _zoom = (parseInt(_zoom * 100) + 50) / 100 >= 5 ? 5 : (parseInt(_zoom * 100) + 50) / 100
    } else {
      _zoom = (parseInt(_zoom * 100) - 50) / 100 <= 0.1 ? 0.1 : (parseInt(_zoom * 100) - 50) / 100
    }
    if (_zoom >= 1) {
      if (_zoom >= 3.5) {
        message.warning('已放至最大！')
        return
      }
      setZoom(_zoom)
      // imgDom.style.transform = `scale( ${_zoom} )`
      imgDom.style.width = imgPX.width * _zoom + 'px'
      imgDom.style.height = imgPX.height * _zoom + 'px'
      // imgDom.style.position = 'absolute'
      // imgDom.style.left = -(_zoom-1)/2*imgPX.width+'px'
      // imgDom.style.top = -(_zoom-1)/2*imgPX.height+'px'
      // imgDom.style.position = 'initial'

      // imgDom.style.transform = `scale( ${_zoom} )`
      // if(_zoom = 1){
      //   imgDom.style.left = "0px"
      //   imgDom.style.top = parseInt(top, 10) + "px"
      //   imgDom.style.position = 'absolute'
      // }
    }
    console.log(_zoom)
  }
  const [pdfModalVisible, setPdfModalVisible] = useState(false) // 控制 PDF 预览模态框的显示与隐藏
  const [pdfUrl, setPdfUrl] = useState('') // 存储当前要预览的 PDF 链接
  
  function handlePreviewPdf(url) {
    const securePdfUrl = url.replace('http://', 'https://')
    setPdfUrl(securePdfUrl)
    convertPdfToImage(securePdfUrl); // 调用转换函数
    setPdfModalVisible(true)
  }
  const [numPages, setNumPages] = useState(null)
  const [pageNumber, setPageNumber] = useState(1)

  function onDocumentLoadSuccess({ numPages }) {
    setNumPages(numPages)
  }
  useEffect(() => {
    if (isOpen) {
      // onDrag()
    }
  }, [isOpen])

  const [isModalOpen, setIsModalOpen] = useState(false)
  const [goodInfo, setGoodInfo] = useState(null)
    const [loading, setLoading] = useState(false)
  // console.log('食安',list)
  //图片加载失败时的处理
  function getFallback(item) {
    let arr = item?.split('.com/') || []
    return arr[0] + '.com/attachment/' + arr[1]
  }
  //检测是否图片类型
  function isAssetTypeImage(filename) {
    const extension = filename?.split('.').pop().toLowerCase()
    return ['png', 'jpg', 'jpeg', 'bmp', 'gif', 'webp', 'psd', 'svg', 'tiff'].includes(extension)
  }
  // 将 PDF 转为图片
  async function convertPdfToImage(url) {
    try {
      const loadingTask = pdfjs.getDocument(url);
      const pdf = await loadingTask.promise;
      const images = [];

      for (let i = 1; i <= pdf.numPages; i++) {
        const page = await pdf.getPage(i);
        const viewport = page.getViewport({ scale: 1.0 });
        const canvas = document.createElement('canvas');
        const context = canvas.getContext('2d');
        canvas.height = viewport.height;
        canvas.width = viewport.width;

        const renderContext = {
          canvasContext: context,
          viewport: viewport
        };

        await page.render(renderContext).promise;
        images.push(canvas.toDataURL('image/png'));
      }
      return images
      // setPdfImages(images);
    } catch (error) {
      console.error('PDF 转换出错:', error);
      message.error('PDF 转换失败，请稍后重试');
    }
  }
  // 显示检验报告
  async function showExaminition(record) {
    console.log('record',record)
    setLoading(true)
    if(record.supplierContractType == 'PDF'){
      // 创建 record 的深拷贝
      const newRecord = JSON.parse(JSON.stringify(record))
      const urls = newRecord.supplierContractUrls.split(',')
      const secureUrls = urls.map(url => url.replace('http://', 'https://'))

      try {
        const allImagesPromises = secureUrls.map(async url => {
          const images = await convertPdfToImage(url, 0.8) // 设置缩放比例为 0.8
          return images
        })
        const supplierContractUrlsToImages = await Promise.all(allImagesPromises)
        newRecord.supplierContractUrlsToImages = supplierContractUrlsToImages
        console.log('supplierContractUrlsToImages', newRecord.supplierContractUrlsToImages)
        setGoodInfo(newRecord)
      } catch (error) {
        console.error('PDF 转换出错:', error)
        message.error('PDF 转换失败，请稍后重试')
      }
      setIsModalOpen(true)
      setLoading(false)
    }else{
      setGoodInfo(record)
      setIsModalOpen(true)
      setLoading(false)
    }
    
  }

  return (
    // overflow:'hidden',
    <Spin spinning={loading} size="large">
    <div className="dingzhi-home-box" style={{ position: 'relative', width: '100%' }}>
      <div style={{padding:'20px'}}>
        <ThirdWebview></ThirdWebview>
      </div>
      
      <div className="dingzhi-btm-box">

        <div className="dingzhi-rank-list" >
          <>{<FoodTraceability list={dataSource1} showExaminitionC={showExaminition}></FoodTraceability>}</>
          <>{<SampleRecord list={sampleRecord} />}</>

        </div>

        <div className="dingzhi-rank-list" style={{marginTop:0}}>
          <>{<InspectionList list={inspectionData} />}</>

          <HotProduct list={hotSaleWindowList} customPic={customPicList} configKeyValue={configValue[1]} />
        </div>

        <div className="dingzhi-rank-list" style={{marginTop:0}}>
          <>{<MorningCheck list={checkData}></MorningCheck>}</>
          <>{<HotWindow list={selectedHotWindowList} customPic={customPicList} configKeyValue={configValue[0]} />}</>
          
        </div>

        <PageFooter style={{ fontSize: '19px', color: '#747474', width: '100%', marginTop:'40px' }}></PageFooter>
      </div>

      
      <Modal
        title="PDF 预览"
        visible={pdfModalVisible}
        onCancel={() => setPdfModalVisible(false)}
        onOk={() => setPdfModalVisible(false)}
        width={1000}>
        <div style={{ height: '1000px', overflow: 'auto' }}>
          <Document
            file={pdfUrl}
            onLoadSuccess={onDocumentLoadSuccess}
            onLoadError={error => {
              console.error('PDF 加载错误:', error)
            }}>
            {Array.from(new Array(numPages), (el, index) => (
              <Page key={`page_${index + 1}`} pageNumber={index + 1} width={800} />
            ))}
          </Document>
        </div>
      </Modal>
      {isOpen && (
        <div className="modal-mask" onClick={() => setIsOpen(false)}>
          <div className="slick-active">
            <img className="img" src={curDbtPicUrl} width={1040} height={260} alt="" title="可拖动" />
          </div>
          <div className="zoomBox">
            <ZoomOutOutlined onClick={() => imgToSize(false)} />
            <ZoomInOutlined onClick={() => imgToSize(true)} />
            <CloseCircleOutlined onClick={() => setIsOpen(false)} />
          </div>
        </div>
      )}
      {isModalOpen && (
        <div className="modal-mask">
          <div className="modal-box">
            <img className="good-img" src={goodInfo.picUrl} />
            <Button
              className="modal-close"
              onClick={() => {
                setGoodInfo(null)
                setIsModalOpen(false)
              }}
              type="primary"
              shape="round"
              size="small">
              <CloseOutlined style={{ color: '#ffffff' }} /> 关闭{' '}
            </Button>
            <div className="good-name">{goodInfo.productName}</div>
            <div className="good-rest">
              {goodInfo.buyerRestaurantName}—{goodInfo.buyerStoreName}
            </div>
            {goodInfo.examiningReportPicUrl && (
              <div>
                <div className="title">检测报告</div>
                <div className="good-cnt">
                  <div className="good-cnt-inner">
                    {goodInfo.examiningReportPicUrl.split(',').map((item, index) => (
                      <div
                        key={index}
                        style={{ width: '200px', marginRight: '20px', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                        {/* <div className="good-time">上传时间 {moment().format('YYYY.MM.DD')}</div> */}
                        {isAssetTypeImage(item) ? (
                          <Image className="exam-img" src={item}></Image>
                        ) : (
                          <Button type="primary" onClick={() => handlePreviewPdf(item)} style={{ borderRadius: '10px' }}>
                            预览 检测报告.PDF
                          </Button>
                        )}
                      </div>
                    ))}
                  </div>
                </div>
              </div>
            )}
            {goodInfo.supplierReportUrls && (
              <div>
                <div className="title">供应商资质</div>
                <div className="good-cnt">
                  <div className="good-cnt-inner">
                    {goodInfo.supplierReportUrls.split(',').map((item, index) => (
                      <div key={index} style={{ width: '300px', marginRight: '20px' }}>
                        {/* <div className="good-time">上传时间 {moment().format('YYYY.MM.DD')}</div> */}
                        <Image className="exam-img" src={item} fallback={getFallback(item)}></Image>
                      </div>
                    ))}
                  </div>
                </div>
              </div>
            )}
            {goodInfo.supplierContractUrls && (
              <div>
                <div className="title">供应商合同</div>
                <div className="good-cnt">
                  <div className={goodInfo.supplierContractType == 'IMG' ? "good-cnt-inner" : "good-cnt-inner1"} style={{maxHeight:'500px'}}>
                    {goodInfo.supplierContractType == 'IMG'
                      ? goodInfo.supplierContractUrls.split(',').map((item, index) => (
                        <div key={index} style={{ width: '300px', marginRight: '20px' }}>
                          {/* <div className="good-time">上传时间 {moment().format('YYYY.MM.DD')}</div> */}
                          {<Image mode="widthFix" className="exam-img" src={item}></Image>}
                        </div>
                      ))
                      : goodInfo.supplierContractUrlsToImages.map((item, index) => (
                        item.map((url,uid)=>(
                          <div key={index+'-'+uid} style={{ width: '200px', marginRight: '20px', marginBottom:'8px', display:'inline-block' }}>
                            <Image className="exam-img" src={url}></Image>
                          </div>
                        ))
                      ))}
                  </div>
                </div>
              </div>
            )}
          </div>
        </div>
      )}
    </div>
    </Spin>
  )
  
}
// webview窗口
function ThirdWebview(){
  return <div className="rank dingzhi-hot-window" style={{background:'linear-gradient(180deg, rgba(255,255,255,1) 18%,rgba(130,201,201,0) 100%)',
  boxShadow: '0px 2px 6px 0px rgba(0,0,0,0.4)',borderRadius:'50px',overflow:'hidden'}}>
          <>
            {/* <div className="rank-header2">消费情况</div> */}
            <div className="rank-body" style={{paddingLeft:0,paddingRight:0}}>
              <iframe 
                src="https://bi.sdvcst.edu.cn:37799/webroot/decision/view/form?viewlet=wlxx%252F%25E5%25AD%25A6%25E7%2594%259F%25E5%25AE%259E%25E6%2597%25B6%25E6%25B6%2588%25E8%25B4%25B9%25E6%2583%2585%25E5%2586%25B5.frm&ref_t=design&ref_c=baaee4d9-947c-4a29-b17d-7083b1a80bee" 
                title="Example Embed"
                width="100%"
                height="420px"
                frameBorder="0"  // React中建议使用camelCase写法
                allowFullScreen
              />
              </div>
          </>
        </div>

}

// 食品安全溯源
function FoodTraceability(propsC){
  console.log(propsC)
  let list = propsC.list
  
  const [settings, setSettings] = useState({
    dots: false,
    infinite: true,
    slidesToShow: 4,
    slidesToScroll: 1,
    autoplay: true,
    vertical: true,
    autoplaySpeed: 2000,
    pauseOnHover: true,
    arrows: false
  })
  useEffect(() => {
    let len = list.length > 0 ? (list.length > 4 ? 4 : list.length) : 1
    setSettings({
      dots: false,
      infinite: true,
      slidesToShow: len,
      slidesToScroll: 1,
      autoplay: true,
      vertical: true,
      autoplaySpeed: 2000,
      pauseOnHover: true,
      arrows: false
    })
    
  }, [list.length])
  
  const [modal, setModal] = useState({
    visible: false,
    info: null
  })
  function closeModal() {
    setModal({ visible: false, info: null })
  }
  return (
    <>
      <div className="rank dingzhi-hot-window" >
         <>
            <div className="rank-header2">食品安全追溯</div>
            <div className="rank-body">
              {list.length>0 && <SliderComponent {...settings} className="slider-inner" style={{ height: '276px' }}>
                {list.map((item, i) => (
                  <div key={i} className='inner-row'onClick={e => {
                  propsC.showExaminitionC(item)
                }}>
                    <Image className="inner-image" style={{borderRadius:'50px',marginRight:'10px'}} preview={false} width={50} height={50} src={item.picUrl} />
                    <div className="inner-item" style={{marginLeft:'10px'}}>
                      <div className='inner-item-left'>
                        <div className="inner-item-left-top">
                          {item.productName}
                        </div>
                        <div className="inner-item-left-btm">
                          {item.buyerRestaurantName}——{item.buyerStoreName}
                        </div>
                      </div>
                      <div className='inner-temp-item-right'>
                        <div className='inner-tempture red'>{'¥' + window.$util.toFixed2(item.payableUnitPrice) + '/' + item.unitName}</div>
                        <div className='inner-tempture-time'>{item.createTime}</div>
                      </div>
                    </div>
                  </div>
                ))}
              </SliderComponent>}
              {
                list.length===0 && <div className="no-data-box">
                <img src={NoDataImg}></img>
                <div className="no-data-txt"></div>
              </div>
              }
            </div>
          </>
      </div>
      <Modal
        className="pages_main_home_HotProduct_modal"
        open={modal.visible}
        onCancel={closeModal}
        footer={null}
        centered
        closable={false}
        width={modal.visible && modal.info.picUrls?.length > 4 ? 782 : ''}>
        {modal.info && (
          <div className="modal-main">
            <div className="health-item">
              {modal.info.picUrls?.map(v => {
                //
                return (
                  <div style={{ marginRight: '7px' }}>
                    <Image width={183} height={183} src={v} alt="背景" key={v.id}></Image>
                  </div>
                )
              })}
            </div>
          </div>
        )}
      </Modal>
      
    </>
  )
}

// 热门窗口
function HotWindow({ list, customPic, configKeyValue }) {
  const [isHealth, setIsHealth] = useState(false)
  const [settings, setSettings] = useState({
    dots: false,
    infinite: true,
    slidesToShow: 4,
    slidesToScroll: 1,
    autoplay: true,
    vertical: true,
    autoplaySpeed: 2000,
    pauseOnHover: true,
    arrows: false
  })
  useEffect(() => {
    let len = list.length > 0 ? (list.length > 4 ? 4 : list.length) : 1
    setSettings({
      dots: false,
      infinite: true,
      slidesToShow: len,
      slidesToScroll: 1,
      autoplay: true,
      vertical: true,
      autoplaySpeed: 2000,
      pauseOnHover: true,
      arrows: false
    })
    if (list.length > 0) {
      list.map(v => {
        v.picUrls = v.picUrls?.split(',')
      })
      console.log('list================>', list)
      let isHealth = list.find(v => v.picUrls)
      if (isHealth) {
        setIsHealth(true)
      } else {
        setIsHealth(false)
      }
    }
  }, [list.length])
  let customPicUrl = 'https://cdn.rongdaufun.com/spa/other/scImgs/rmck.png'
  if (configKeyValue == 2) {
    let pic = customPic[0]
    customPicUrl = pic ? pic[0].url : 'https://cdn.rongdaufun.com/spa/other/scImgs/rmck.png'
  }

  function ImgOrVideo({ item }) {
    let isVideo = item.includes('.mp4') || item.includes('.avi') || item.includes('.mov') || item.includes('.flv')
    let suffix = 'mp4'
    if (isVideo) {
      // console.log('video',item)
      if (item.includes('/NEWS/')) {
        suffix = item.split('NEWS')[1].split('.')[1].split('?')[0]
      } else {
        suffix = item.split('.com/')[1].split('.')[1]
      }
    }

    return isVideo ? (
      <video className="goods-img cover" autoPlay loop controls src={item} type={'video/' + suffix}></video>
    ) : (
      <img className="goods-img cover" mode="scaleToFill" src={item} />
    )
  }
  const [modal, setModal] = useState({
    visible: false,
    info: null
  })
  function openModal(item) {
    setModal({ visible: true, info: item })
  }
  function closeModal() {
    setModal({ visible: false, info: null })
  }
  return (
    <>
      <div className="rank dingzhi-hot-window"  style={{marginTop:'35px'}}>
        {
          configKeyValue == 1 ? (
            <>
              <div className="rank-header2">{isHealth ? '健康证' : '热门窗口'}</div>
              <div className="rank-body">
                <SliderComponent {...settings} className="slider-inner" style={{ height: '276px' }}>
                  {list.map((item, i) => (
                    <div key={i}>
                      <div className="inner-item">
                        <div className="item-rest">{isHealth ? item.buyerRestaurantName : item.restaurantName}</div>
                        <div className="item-store">{isHealth ? item.buyerStoreName : item.windowName}</div>
                        <div className="item-value-outer">
                          {isHealth ? (
                            item.picUrls && item.picUrls.length > 0 ? (
                              <img className="corner-img" src={fireHealth} />
                            ) : (
                              ''
                            )
                          ) : (
                            <img className="corner-img" src={fireRedCornerImg} />
                          )}
                          {
                            isHealth ? (
                              item.picUrls && item.picUrls.length > 0 ? (
                                <div style={{ color: '#3FA5FF' }} onClick={() => openModal(item)}>
                                  查看健康证
                                </div>
                              ) : (
                                '暂无健康证'
                              )
                            ) : (
                              <div className="item-value">{item.hotValue}</div>
                            )
                            // (item.healthImg && item.healthImg.length > 0) ? <div style={{ color: '#3FA5FF' }} onClick={() => openModal(item)}>查看健康证</div> : <div className="item-value">{item.hotValue}</div>
                          }
                        </div>
                      </div>
                    </div>
                  ))}
                </SliderComponent>
                {/* <img className="body-bg" src={fireBgImg} /> */}
              </div>
            </>
          ) : (
            <Carousel autoplay dots={false}>
              {customPic &&
                customPic[0] &&
                customPic[0].map((item, index) => (
                  <div className="goods-img cover" key={index}>
                    <ImgOrVideo item={item.url} />
                  </div>
                ))}
            </Carousel>
          )
          // <ImgOrVideo item={customPicUrl}></ImgOrVideo>
          // <img className="goods-img cover" src={customPicUrl} />
        }
      </div>
      <Modal
        className="pages_main_home_HotProduct_modal"
        open={modal.visible}
        onCancel={closeModal}
        footer={null}
        centered
        closable={false}
        width={modal.visible && modal.info.picUrls?.length > 4 ? 782 : ''}>
        {modal.info && (
          <div className="modal-main">
            <div className="health-item">
              {modal.info.picUrls?.map(v => {
                //
                return (
                  <div style={{ marginRight: '7px' }}>
                    <Image width={183} height={183} src={v} alt="背景" key={v.id}></Image>
                  </div>
                )
              })}
            </div>
          </div>
        )}
      </Modal>
    </>
  )
}

// 热销商品
function HotProduct({ list, customPic, configKeyValue }) {
  let _list = []
  // let customPicUrl = 'https://cdn.rongdaufun.com/spa/other/scImgs/rxsp.png'
  if (configKeyValue == 2) {
    let pic = customPic[1]
    // customPicUrl = pic?pic[0].url : 'https://cdn.rongdaufun.com/spa/other/scImgs/rxsp.png'
  } else {
    _list = _.chunk(list, 3)
  }
  console.log('_list', _list)
  const [settings, setSettings] = useState({
    dots: false,
    infinite: true,
    slidesToShow: 2,
    slidesToScroll: 1,
    autoplay: true,
    vertical: true,
    autoplaySpeed: 2000,
    pauseOnHover: true,
    arrows: false
  })
  function ImgOrVideo({ item }) {
    let isVideo = item.includes('.mp4') || item.includes('.avi') || item.includes('.mov') || item.includes('.flv')
    let suffix = 'mp4'
    if (isVideo) {
      if (item.includes('/NEWS/')) {
        suffix = item.split('NEWS')[1].split('.')[1].split('?')[0]
      } else {
        suffix = item.split('.com/')[1].split('.')[1]
      }
    }

    return isVideo ? (
      <video className="goods-img cover" autoPlay loop controls src={item} type={'video/' + suffix}></video>
    ) : (
      <img className="goods-img cover" mode="scaleToFill" src={item} />
    )
  }
  const [modal, setModal] = useState({
    visible: false,
    info: null
  })
  function openModal(item) {
    setModal({ visible: true, info: item })
  }
  function closeModal() {
    setModal({ visible: false, info: null })
  }

  return (
    <>
      <div className="rank dingzhi-hot-product" style={{ background: `url(${hotBg})`, backgroundRepeat: 'no-repeat', marginTop:'35px' }}>
        {
          configKeyValue == 1 ? (
            <>
              <div className="rank-header2">{storeUser.getState().sysuserInfo.buyerOrgId == '27' ? '供应商合同' : '热销商品'}</div>
              <div className="rank-body">
                <SliderComponent {...settings} className="slider-inner">
                  {_list.map((item, i) => (
                    <div key={i}>
                      <div className="inner-item">
                        {item[0] && (
                          <div className="goods" onClick={() => openModal(item[0])}>
                            {item[0].pic.length > 0 ? (
                              <div style={{ width: '100%', height: '100%' }}>
                                <img className="goods-img" src={item[0].pic[0].url} />
                                <div className="goods-corner">
                                  <img className="corner-img" src={fireCornerImg} />
                                  <div className="corner-text">{item[0].hotValue}</div>
                                </div>
                              </div>
                            ) : (
                              ''
                            )}
                          </div>
                        )}
                        {item[1] && (
                          <div className="goods" onClick={() => openModal(item[1])}>
                            {item[1].pic.length > 0 ? (
                              <div style={{ width: '100%', height: '100%' }}>
                                <img className="goods-img" src={item[1].pic[0].url} />
                                <div className="goods-corner">
                                  <img className="corner-img" src={fireCornerImg} />
                                  <div className="corner-text">{item[1].hotValue}</div>
                                </div>
                              </div>
                            ) : (
                              ''
                            )}
                          </div>
                        )}
                        {item[2] && (
                          <div className="goods">
                            {item[2].pic.length > 0 ? (
                              <div style={{ width: '100%', height: '100%' }}>
                                <img className="goods-img" src={item[2].pic[0].url} onClick={() => openModal(item[2])} />
                                <div className="goods-corner">
                                  <img className="corner-img" src={fireCornerImg} />
                                  <div className="corner-text">{item[2].hotValue}</div>
                                </div>
                              </div>
                            ) : (
                              ''
                            )}
                          </div>
                        )}
                      </div>
                    </div>
                  ))}
                </SliderComponent>
              </div>
            </>
          ) : (
            <Carousel autoplay dots={false}>
              {customPic &&
                customPic[1] &&
                customPic[1].map((item, index) => (
                  <div className="goods-img cover" key={index}>
                    <ImgOrVideo item={item.url} />
                  </div>
                ))}
            </Carousel>
          )
          // <ImgOrVideo item={customPicUrl}></ImgOrVideo>
          // <img className="goods-img cover" src={customPicUrl} />
        }
      </div>

      <Modal
        className="pages_main_home_HotProduct_modal"
        open={modal.visible}
        onCancel={closeModal}
        footer={null}
        centered
        closable={false}
        width={719}>
        {/* {modal.info && (
          <div className="modal-main">
            <img className="modal-img" src={modal.info.picAbs.url} />
            <div className="modal-bottom">
              <div className="modal-goods-name">{modal.info.goodsName}</div>
              <div className="modal-store-name">{modal.info.windowName}</div>
            </div>
          </div>
        )} */}
        {modal.info && (
          <div className="modal-main" style={{ backgroundColor: '#CECECE' }}>
            <div className="modal-bottom">
              <div className="modal-store-name">{modal.info.goodsName}</div>
              <div className="modal-store-name" style={{ marginLeft: '20px' }}>
                {modal.info.windowName}
              </div>
            </div>
            <div className="health-item">
              {modal.info.pic?.map(v => {
                //
                return (
                  <div style={{ marginRight: '7px' }}>
                    <Image width={183} height={183} src={v.url} alt="背景" key={v.id}></Image>
                  </div>
                )
              })}
            </div>
          </div>
        )}
      </Modal>
    </>
  )
}


// 留样记录
function SampleRecord({ list }) {
 
  const [settings, setSettings] = useState({
    dots: false,
    infinite: true,
    slidesToShow: 4,
    slidesToScroll: 1,
    autoplay: true,
    vertical: true,
    autoplaySpeed: 2000,
    pauseOnHover: true,
    arrows: false
  })
  useEffect(() => {
    let len = list.length > 0 ? (list.length > 4 ? 4 : list.length) : 1
    setSettings({
      dots: false,
      infinite: true,
      slidesToShow: len,
      slidesToScroll: 1,
      autoplay: true,
      vertical: true,
      autoplaySpeed: 2000,
      pauseOnHover: true,
      arrows: false
    })
    
  }, [list.length])
  
  const [modal, setModal] = useState({
    visible: false,
    info: null
  })
  function openModal(item) {
    setModal({ visible: true, info: item })
  }
  function closeModal() {
    setModal({ visible: false, info: null })
  }
  const enmu_state = {
    KEEP:'已留样',
    DISPOSE:'已销毁'
  }
  return (
    <>
      <div className="rank dingzhi-hot-window" >
         <>
            <div className="rank-header2">留样记录</div>
            <div className="rank-body">
              <SliderComponent {...settings} className="slider-inner" style={{ height: '276px' }}>
                {list.map((item, i) => (
                  <div key={i} className='inner-row'>
                    <Image className="corner-img" style={{borderRadius:'6px'}} preview={true} src={item.samplePicture} />
                    <div className="inner-item" style={{width:'100%'}}>
                      <div className='inner-item-left'>
                        <div className="inner-item-left-top" style={{display:'flex'}}>
                          <div className="" >{item.menuName}</div>
                          <span>({item.weight}g/{item.meal})</span>
                        </div>
                        <div className="inner-item-left-btm"style={{display:'flex'}}>
                          {/* {item.buyerRestaurantName} <div className='devider'>|</div> */}
                          
                          <div className="" style={{maxWidth:'160px',whiteSpace:'nowrap',overflow:'hidden',textOverflow:'ellipsis'}}>{item.buyerStoreName}</div>
                          <div className='devider'>|</div>
                          {item.storageCondition} <div className='devider'>|</div> 保存{item.storageDuration||48}小时
                        </div>
                      </div>
                      <div className='inner-item-right'>
                        已留样
                      </div>
                      {/* {item.sampleState == 'KEEP' && <div className='inner-item-right'>
                        {enmu_state[item.sampleState]}
                      </div>}
                      {item.sampleState == 'DISPOSE' && <div className='inner-item-right fail'>
                        {enmu_state[item.sampleState]}
                      </div>} */}
                    </div>
                  </div>
                ))}
              </SliderComponent>
            </div>
          </>
      </div>
      <Modal
        className="pages_main_home_HotProduct_modal"
        open={modal.visible}
        onCancel={closeModal}
        footer={null}
        centered
        closable={false}
        >
        {modal.info && (
          <div className="modal-main">
            <div className="health-item">
              <div style={{ marginRight: '7px' }}>
                <Image width={183} height={183} src={modal.info.samplePicture} alt="背景" ></Image>
              </div>
            </div>
          </div>
        )}
      </Modal>
    </>
  )
}

// 交易明细
function TradeList({ list }) {
 
  const [settings, setSettings] = useState({
    dots: false,
    infinite: true,
    slidesToShow: 4,
    slidesToScroll: 1,
    autoplay: true,
    vertical: true,
    autoplaySpeed: 2000,
    pauseOnHover: true,
    arrows: false
  })
  useEffect(() => {
    let len = list.length > 0 ? (list.length > 4 ? 4 : list.length) : 1
    setSettings({
      dots: false,
      infinite: true,
      slidesToShow: len,
      slidesToScroll: 1,
      autoplay: true,
      vertical: true,
      autoplaySpeed: 2000,
      pauseOnHover: true,
      arrows: false
    })
    
  }, [list.length])
  
  const [modal, setModal] = useState({
    visible: false,
    info: null
  })
  function closeModal() {
    setModal({ visible: false, info: null })
  }
  return (
    <>
      <div className="rank dingzhi-hot-window" >
         <>
            <div className="rank-header2">交易明细</div>
            <div className="rank-body">
              <SliderComponent {...settings} className="slider-inner" style={{ height: '276px' }}>
                {list.map((item, i) => (
                  <div key={i} className='no-img-inner-row'>
                    <div className="inner-item">
                      <div className='inner-item-left'>
                        <div className="inner-item-left-top">
                          {item.terminal}
                          {/* <span>{item.meal}</span> */}
                        </div>
                        <div className="inner-item-left-btm">
                          {/* {item.time} <div className='devider'></div> */}
                          {item.name} <div className='devider'></div>
                          {item.type}
                        </div>
                      </div>
                      <div className='right-price'>
                        ￥{item.amount}
                      </div>
                    </div>
                  </div>
                ))}
              </SliderComponent>
            </div>
          </>
      </div>
      <Modal
        className="pages_main_home_HotProduct_modal"
        open={modal.visible}
        onCancel={closeModal}
        footer={null}
        centered
        closable={false}
        width={modal.visible && modal.info.picUrls?.length > 4 ? 782 : ''}>
        {modal.info && (
          <div className="modal-main">
            <div className="health-item">
              {modal.info.picUrls?.map(v => {
                //
                return (
                  <div style={{ marginRight: '7px' }}>
                    <Image width={183} height={183} src={v} alt="背景" key={v.id}></Image>
                  </div>
                )
              })}
            </div>
          </div>
        )}
      </Modal>
    </>
  )
}

// 巡查巡检
function InspectionList({ list }) {
  
	const user = useSelector(state => state.sysuserInfo || {})
  const [settings, setSettings] = useState({
    dots: false,
    infinite: true,
    slidesToShow: 4,
    slidesToScroll: 1,
    autoplay: true,
    vertical: true,
    autoplaySpeed: 2000,
    pauseOnHover: true,
    arrows: false
  })
  useEffect(() => {
    let len = list.length > 0 ? (list.length > 4 ? 4 : list.length) : 1
    setSettings({
      dots: false,
      infinite: true,
      slidesToShow: len,
      slidesToScroll: 1,
      autoplay: true,
      vertical: true,
      autoplaySpeed: 2000,
      pauseOnHover: true,
      arrows: false
    })
    
  }, [list.length])
  
  const [modal, setModal] = useState({
    visible: false,
    info: null
  })
  function openModal(item) {
    setModal({ visible: true, info: item })
  }
  function closeModal() {
    setModal({ visible: false, info: null })
  }
  const resultEnum = {
    'PASS': '合格',
    'FAIL': '不合格'
  }
  return (
    <>
      <div className="rank dingzhi-hot-window" style={{marginTop:'35px'}}>
         <>
            <div className="rank-header2">巡查巡检</div>
            <div className="rank-body">
              <SliderComponent {...settings} className="slider-inner" style={{ height: '276px' }}>
                {list.map((item, i) => (
                  <div key={i} className='inner-row'>
                    {item.inspectionImg && <img className="corner-img" onClick={()=>openModal(item)} src={item.inspectionImg.split(',')[0]} />}
                    {!item.inspectionImg && <img className="corner-img" src={user.logoUrl} />}
                    <div className="inner-item">
                      <div className='inner-item-left'>
                        <div className="inner-item-left-top" style={{display:'flex'}}>
                          <div className="" style={{maxWidth:'200px',whiteSpace:'nowrap',overflow:'hidden',textOverflow:'ellipsis'}}>{item.projectName}</div>
                          {/* {item.projectName} */}
                          <span>{item.creator}</span>
                        </div>
                        <div className="inner-item-left-btm" style={{display:'flex'}}>
                          {item.inspectionTime} <div className='devider'>|</div>
                          <div className="" style={{maxWidth:'160px',whiteSpace:'nowrap',overflow:'hidden',textOverflow:'ellipsis'}}>{item.investigativeDivision}</div>
                          {/* {item.investigativeDivision} */}
                        </div>
                      </div>
                      {item.projectResult ==='PASS' && <div className='inner-item-right-green'>
                        {resultEnum[item.projectResult]}
                      </div>}
                      {item.projectResult ==='FAIL' && <div className='inner-item-right-red'>
                        {resultEnum[item.projectResult]}
                      </div>}
                    </div>
                  </div>
                ))}
              </SliderComponent>
            </div>
          </>
      </div>
      <Modal
        className="pages_main_home_HotProduct_modal"
        open={modal.visible}
        onCancel={closeModal}
        footer={null}
        centered
        closable={false}
        width={modal.visible && modal.info.inspectionImg.split(',')?.length > 4 ? 782 : ''}>
        {modal.info && (
          <div className="modal-main">
            <div className="health-item">
              {modal.info.inspectionImg.split(',')?.map(v => {
                //
                return (
                  <div style={{ marginRight: '7px' }}>
                    <Image width={183} height={183} src={v} alt="背景" key={v.id}></Image>
                  </div>
                )
              })}
            </div>
          </div>
        )}
      </Modal>
    </>
  )
}

// 晨检记录
function MorningCheck({ list }) {
 
  const [settings, setSettings] = useState({
    dots: false,
    infinite: true,
    slidesToShow: 4,
    slidesToScroll: 1,
    autoplay: true,
    vertical: true,
    autoplaySpeed: 2000,
    pauseOnHover: true,
    arrows: false
  })
  useEffect(() => {
    let len = list.length > 0 ? (list.length > 4 ? 4 : list.length) : 1
    setSettings({
      dots: false,
      infinite: true,
      slidesToShow: len,
      slidesToScroll: 1,
      autoplay: true,
      vertical: true,
      autoplaySpeed: 2000,
      pauseOnHover: true,
      arrows: false
    })
    
  }, [list.length])
  
  const [modal, setModal] = useState({
    visible: false,
    info: null
  })
  function closeModal() {
    setModal({ visible: false, info: null })
  }
  return (
    <>
      <div className="rank dingzhi-hot-window" style={{marginTop:'35px'}}>
         <>
            <div className="rank-header2">晨检记录</div>
            <div className="rank-body">
              <SliderComponent {...settings} className="slider-inner" style={{ height: '276px' }}>
                {list.map((item, i) => (
                  <div key={i} className='inner-row'>
                    {item.temperatureNormal === 0 && <CheckCircleOutlined style={{color:'green',fontSize:'36px',marginRight:'8px'}} />}
                    {item.temperatureNormal === 1 && <CloseCircleOutlined style={{color:'red',fontSize:'36px',marginRight:'8px'}} />}
                    <div className="inner-item">
                      <div className='inner-item-left'>
                        <div className="inner-item-left-top">
                          {item.staffName}
                        </div>
                        <div className="inner-item-left-btm">
                          {item.restaurantName}
                        </div>
                      </div>
                      <div className='inner-temp-item-right'>
                        {(item.temperatureNormal === 0) && <div className='inner-tempture green'>{item.temperature}℃</div>}
                        {(item.temperatureNormal === 1) && <div className='inner-tempture red'>{item.temperature}℃</div>}
                        <div className='inner-tempture-time'>{item.recordTime}</div>
                      </div>
                    </div>
                  </div>
                ))}
              </SliderComponent>
            </div>
          </>
      </div>
      <Modal
        className="pages_main_home_HotProduct_modal"
        open={modal.visible}
        onCancel={closeModal}
        footer={null}
        centered
        closable={false}
        width={modal.visible && modal.info.picUrls?.length > 4 ? 782 : ''}>
        {modal.info && (
          <div className="modal-main">
            <div className="health-item">
              {modal.info.picUrls?.map(v => {
                //
                return (
                  <div style={{ marginRight: '7px' }}>
                    <Image width={183} height={183} src={v} alt="背景" key={v.id}></Image>
                  </div>
                )
              })}
            </div>
          </div>
        )}
      </Modal>
    </>
  )
}